import { useParams } from "react-router-dom";
import NavigationBar from "../../components/navbar/component";
import Image from '../../image/ArticleNewsCover.png'
import { getArticleDetail } from "../../api";
import { useEffect, useState } from "react";
import { 
    ArticleWrapper, 
    ArticleTitle, 
    ArticleAuthor, 
    ArticleDate, 
    Section, 
    ImageWrapper, 
    ImageCSS
} from "./style";
import {
    Footer
} from '../../components/footer/components'

export const ArticleDetail = () => {
    const { id } = useParams();
    const [article, setArticle] = useState(null);

    useEffect(async() => {
        const data = await getArticleDetail(id);
        setArticle(data.data.data);
        console.log(data.data.data);
    }, []);

    const formatDate = (date) => {
        const dateObj = new Date(date);

        const day = dateObj.getDate();
        const monthName = dateObj.toLocaleString('en-US', { month: 'long' });
        const year = dateObj.getFullYear();
        return `${day} ${monthName} ${year}`;
    }

    return (
        <div>
            <NavigationBar />

            <Section>
                <ImageWrapper >
                    <ImageCSS 
                        src={Image} 
                        alt="" 
                    ></ImageCSS>
                </ImageWrapper>
            </Section>
            {article && (
                <ArticleWrapper>
                    <ArticleDate>
                        {formatDate(article.created_at)}
                    </ArticleDate>
                    <ArticleTitle>
                        {article.title}
                    </ArticleTitle>
                    <ArticleAuthor>
                        Article by: {article.created_by}
                    </ArticleAuthor>
                    <div dangerouslySetInnerHTML={{ __html: article.body }} />
                </ArticleWrapper>
            )}
            <Footer />
        </div>
    )
}